import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#bf2f38",
        },
        secondary: {
            main: "#FFFFFF",
        },
    },
    typography: {
        fontFamily: ["Poppins"].join(","),
    },
});
